import { useState } from 'react'
import ReactHtmlParser from 'react-html-parser'
import type { IAgreementPreviewItem } from '~/@api/generated-api-types-user/Api'
import { Text } from '~/@mid_ui/typography/Text'

type Props = {
  agreementSk: IAgreementPreviewItem
  agreementLang: IAgreementPreviewItem | undefined
}

function AgreementPreview(props: Props) {
  const [showContent2, setShowContent2] = useState(false)
  const [showSign, setShowSign] = useState(false)

  const agreementSk = props.agreementSk
  const agreementLang = props.agreementLang

  if (!agreementSk) return null

  return (
    <table
      className={`agreement-table agreement-table-${agreementLang ? 'double' : 'single'}`}>
      <tbody>
        <tr>
          <td className={`column-${agreementLang ? 'left' : 'single'}`}>
            <div className={'agreement-content'}>
              {ReactHtmlParser(agreementSk.content)}
              {(agreementSk.content2 ||
                (agreementLang && agreementLang.content2)) &&
                (showContent2 ? (
                  <>{ReactHtmlParser(agreementSk.content2)}</>
                ) : (
                  <a
                    href={'#'}
                    onClick={(event) => {
                      event.preventDefault()
                      setShowContent2(true)
                      setShowSign(true)
                    }}>
                    <Text className="text-accent underline">Zobraziť viac</Text>
                  </a>
                ))}
            </div>
          </td>
          {agreementLang && agreementLang.content2 && (
            <td className={'column-right'}>
              <div className={'agreement-content'}>
                {ReactHtmlParser(agreementLang.content)}
                {showContent2 && ReactHtmlParser(agreementLang.content2)}
              </div>
            </td>
          )}
        </tr>
        {showSign && agreementSk && agreementSk.sign && (
          <tr>
            <td
              className={'agreement-signature'}
              colSpan={agreementLang ? 2 : undefined}>
              <div className={'agreement-content'}>
                {ReactHtmlParser(agreementSk.sign)}
              </div>
            </td>
          </tr>
        )}
      </tbody>
    </table>
  )
}

export { AgreementPreview }
